/**
 * Reviewer-facing status chip wording (distinct from ./status.ts's plain valuer wording —
 * the reviewer needs to see queued/checking/checked/reviewing/done, not a collapsed
 * "in progress"). See ../screens/reviewer and DESIGN.md status-mark colours.
 */
export type ChipTone = 'neutral' | 'checking' | 'reviewing' | 'done' | 'error' | 'attention';

export interface StatusChipMeta {
  label: string;
  tone: ChipTone;
  /** The "checking" chip animates so the reviewer knows the AI pass is mid-flight. */
  animate: boolean;
}

export function reviewerStatusChip(status: string): StatusChipMeta {
  switch (status) {
    case 'uploaded':
    case 'queued':
      return { label: 'Queued', tone: 'neutral', animate: false };
    case 'checking':
      return { label: 'Checking', tone: 'checking', animate: true };
    case 'checked':
      return { label: 'Checked', tone: 'neutral', animate: false };
    case 'reviewing':
      return { label: 'Reviewing', tone: 'reviewing', animate: false };
    case 'done':
      return { label: 'Done', tone: 'done', animate: false };
    case 'error':
      return { label: 'Error', tone: 'error', animate: false };
    case 'changes_requested':
      return { label: 'Changes requested', tone: 'attention', animate: false };
    default:
      return { label: status, tone: 'neutral', animate: false };
  }
}
